import { dataFetcher } from 'core/services/requestHandler';   


export const getVendorDashboardData = async (data = {}, config = {}) => {
  return dataFetcher('vendor/dashboard', data, {...config});
};

export const getVendorCoupons = async (data = {}, config = {}, path={}) => {
  const { vendorId } = path;
  return dataFetcher(`vendor/coupons/${vendorId}`, data, {...config});
};

export const getVendorEnquiries = async (data = {}, config = {}, path={}) => {
  const { vendorId } = path;
  return dataFetcher(`vendor/enquiries/${vendorId}`, data, {...config});
};

export const getVendorPasses = async (data = {}, config = {}, path={}) => {
  const { vendorId } = path;
  return dataFetcher(`vendor/passes/${vendorId}`, data, {...config});
};

export const getVendorExpenses = async (data = {}, config = {}) => {
  return dataFetcher(`vendor/expenses`, data, {...config});
};

export const getVendorIncentives = async (data = {}, config = {}) => {
  return dataFetcher(`vendor/incentives`, data, {...config});
};

export const getVendorDues = async (data = {}, config = {}) => {
  return dataFetcher(`vendor/dues`, data, {...config});
};

export const getVendorPayouts = async (data = {}, config = {}) => {
  return dataFetcher(`vendor/payouts`, data, {...config});
};

export const getVendorBookings = async (data = {}, config = {}) => {
  return dataFetcher(`vendor/bookings`, data, {...config});
};

export const getVendorLayout = async (data = {}, config = {}) => {
  return dataFetcher(`vendor/seatLayout`, data, {...config});
};

export const getVendorWalletTransactions   = async (data = {}, config = {}, path={}) => {
  const { vendorId } = path;
  return dataFetcher(`vendor/walletTransactions/${vendorId}`, data, {...config});
};
